import React from 'react';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import { Box, Stack, TextField } from '@mui/material';
import type { RemarkBoxValue, FormikProp } from './types';
import { type ApplicationRemarkType } from '../../../graphql';
import { PAGE_TEXT } from '../../lang';
import { Accordion, Button, UserRole } from '../../../../../components';
import { theme } from '../../../../../Theme';

type RemarkContentProps = {
  returnedRemarks: ApplicationRemarkType[];
  isViewMode: boolean;
  initialValues: RemarkBoxValue;
  onSubmit: (values: RemarkBoxValue) => void;
};

export const ReturnedRemarksDisplay = (
  title: string,
  remarkArr: ApplicationRemarkType[],
): React.ReactNode => {
  return (
    Boolean(remarkArr.length) && (
      <div className="mt-2">
        <h3 className="font-semibold">{title}</h3>
        {remarkArr.map((rmk, index) => {
          const { remark, createdAt } = rmk;
          const updateTime =
            ' (at ' + dayjs(createdAt).format('DD/MM/YYYY') + ')';
          return (
            <TextField
              className="!mt-2"
              key={index}
              value={remark + updateTime}
              minRows={3}
              disabled
              multiline
              fullWidth
            />
          );
        })}
      </div>
    )
  );
};
export const RemarkContent: React.FunctionComponent<
  RemarkContentProps
> = props => {
  const { initialValues, onSubmit, isViewMode, returnedRemarks } = props;
  const formik: FormikProp = useFormik({
    initialValues,
    onSubmit,
  });
  const remarksFromDorpgs = returnedRemarks.filter(
    rmk =>
      rmk.fromRole === UserRole.DO_RPG_S &&
      rmk.toRole.includes(UserRole.SUPERVISOR),
  );

  const remarksFromGs = returnedRemarks.filter(
    rmk =>
      rmk.fromRole === UserRole.GS && rmk.toRole.includes(UserRole.SUPERVISOR),
  );

  const hasReturnHistory =
    Boolean(remarksFromGs.length) || Boolean(remarksFromDorpgs.length);

  return (
    <div className="mt-[1rem]">
      <Accordion
        className="w-full"
        title={PAGE_TEXT.REMARKS.TITLE}
        defaultExpanded
        disableExpand
        details={
          <form onSubmit={formik.handleSubmit} noValidate>
            <Stack className="p-2">
              {hasReturnHistory && (
                <Box padding={2} bgcolor={theme.palette.grey['200']}>
                  {ReturnedRemarksDisplay(
                    PAGE_TEXT.REMARKS.SUBTITLE_GS,
                    remarksFromGs,
                  )}
                  {ReturnedRemarksDisplay(
                    PAGE_TEXT.REMARKS.SUBTITLE_DORPGS,
                    remarksFromDorpgs,
                  )}
                </Box>
              )}
              <Box padding={2}>
                <h3 className="font-bold mb-4">{PAGE_TEXT.REMARKS.SUBTITLE}</h3>
                <TextField
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="scalar"
                  disabled={isViewMode}
                  value={formik.values.scalar}
                  minRows={3}
                  multiline
                  fullWidth
                />
              </Box>
              <Box textAlign={'center'} marginY={5}>
                {!isViewMode && (
                  <Button variant="contained" type="submit">
                    {PAGE_TEXT.SAVE}
                  </Button>
                )}
              </Box>
            </Stack>
          </form>
        }
      />
    </div>
  );
};
